module.exports = __webpack_public_path__ + "static/about-image-5_d-8c7dff9918cdba94ca9e897d969c1d90.jpg";